export default "__VITE_ASSET__GASiY3I3__"